import React from 'react';

export function TimelineChecked({ size = 40 }): JSX.Element {
  return (
    <svg viewBox='0 0 39.73 32.61' width={size} height={size}>
      <path d='M16.16 32.61L.65 17.86a2.1 2.1 0 012.9-3L15.72 26.4 36 .8a2.1 2.1 0 113.29 2.61z' fill='#fff' />
    </svg>
  );
}
